import { Collapse } from "@material-ui/core";
import React, { PropsWithChildren, useEffect, useRef, useState } from "react";

interface ExpandableTextProps {
  collapsedSize: number;
}

export const ExpandableText = (
  props: PropsWithChildren<ExpandableTextProps>,
): JSX.Element => {
  const { children } = { ...props };
  const [collapsedSize, setCollapsedSize] = useState(props.collapsedSize);
  const [expanded, setExpanded] = useState(false);
  const [truncated, setTruncated] = useState(false);

  const div = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (div.current) {
      if (div.current.getBoundingClientRect().height > collapsedSize) {
        setTruncated(true);
      } else {
        setCollapsedSize(div.current.getBoundingClientRect().height);
        setTruncated(false);
      }
    }
  }, [div, collapsedSize]);

  return (
    <div>
      <Collapse in={expanded} collapsedSize={collapsedSize}>
        <div ref={div}>{children}</div>
      </Collapse>
      {truncated && (
        <div
          className="w-full text-right italic point-on-hover"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "(less)" : "(more)"}
        </div>
      )}
    </div>
  );
};
